import i18n from 'i18n';

export const getFormattedDateString = (timestamp: string) =>
    new Date(timestamp).toLocaleDateString(i18n.language, {
        day: '2-digit',
        month: '2-digit',
    });
